import moment from 'moment';
import { getAffectationProduitUnitaireAsync } from '@/api/affectation/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import calculArrondi from '@/services/calcul/calculArrondi';

const TYPE_REFERENCE_DEVIS = 'Devis';
export const SURFACE_MAX = 100;

function chevauche(affectation, budget) {
  return moment(affectation.dureeAffectation.dateDebut).isSameOrBefore(moment(budget.dateFin), 'day')
    && moment(affectation.dureeAffectation.dateFin).isSameOrAfter(moment(budget.dateDebut), 'day');
}

function estActiveLe(affectation, date) {
  return moment(affectation.dureeAffectation.dateDebut).isSameOrBefore(date, 'day')
    && (!affectation.dureeAffectation.dateFin || moment(affectation.dureeAffectation.dateFin).isSameOrAfter(date, 'day'));
}

function getSurfaceOccupeeBudget(affectations, budget) {
  const affectationsBudget = affectations.filter(affectation => chevauche(affectation, budget));
  if (!affectationsBudget.length) return 0;
  const surfaceMax = Math.max(...affectationsBudget.map((affectationDebut) => {
    const date = moment(affectationDebut.dureeAffectation.dateDebut);
    return affectationsBudget
      .filter(affectation => estActiveLe(affectation, date))
      .reduce((total, affectation) => total + (affectation.quantiteDispo != null ? affectation.quantiteDispo : 1), 0);
  }));
  return surfaceMax * SURFACE_MAX;
}

export async function getSurfaceOccupee(produitId, budgets, recommandationId) {
  const budgetsDates = budgets.filter(budget => budget.dateDebut && budget.dateFin);
  if (!produitId || !budgetsDates.length) return 0;

  const produits = budgetsDates.map(budget => ({
    id: produitId,
    dureeAffectation: {
      dateDebut: formatIsoDate(budget.dateDebut),
      dateFin: formatIsoDate(budget.dateFin),
    },
  }));
  const affectationsParProduit = (await getAffectationProduitUnitaireAsync(produits, true)).data.result;
  const affectations = (affectationsParProduit[produitId] || [])
    .filter(affectation => affectation.referenceId !== recommandationId)
    .filter(affectation => !(affectation.typeReference === TYPE_REFERENCE_DEVIS && affectation.estCommande));

  const surfaceOccupee = Math.max(...budgetsDates.map(budget => getSurfaceOccupeeBudget(affectations, budget)));
  return calculArrondi(surfaceOccupee);
}


export function getSurfaceProposee(surfaceOccupee) {
  const surfaceRestante = calculArrondi(SURFACE_MAX - surfaceOccupee);
  return Math.max(surfaceRestante, 0);
}

export function quantiteDispoToPourcentageSurface(quantiteDispo) {
  return quantiteDispo != null ? calculArrondi(quantiteDispo * SURFACE_MAX) : SURFACE_MAX;
}
